module.exports = __webpack_public_path__ + "img/T003_Shopping.8047e3f9.png";